import React from "react"
import { Link, graphql } from "gatsby"

import ReactGA from 'react-ga';

import Bio from "../components/bio"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { rhythm } from "../utils/typography"

import './index.css'

class BlogIndex extends React.Component {
  componentDidMount(){
    ReactGA.initialize('UA-174649419-1');
    ReactGA.pageview(window.location.pathname + window.location.search);
  }
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title
    const posts = data.allMarkdownRemark.edges

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title="SMART BLOG"
          keywords={[`blog`, `gatsby`, `javascript`, `react`]}
        />
        <Bio />
        {posts.map(({ node }) => {
          const title = node.frontmatter.title || node.fields.slug
          return (
            <Link
              style={{ boxShadow: `none`, color: "#222" }}
              to={node.fields.slug}
            >
              <div
                className="post"
                key={node.fields.slug}
                style={{
                  backgroundColor: "#fff",
                  color: "#000000",
                  border: "5px #222222 solid",
                  borderRadius: "3% ",
                  marginBottom: "5px",
                  transition: 'width 2s, height 4s'
                }}
              >
                <div style={{ paddingLeft: "10px" }}>
                  <h3
                    style={{
                      marginBottom: rhythm(1 / 4),
                    }}
                  >
                    {title}
                  </h3>
                  <small>{node.frontmatter.date}</small>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: node.frontmatter.description || node.excerpt,
                    }}
                  />
                </div>
              </div>
            </Link>
          )
        })}
      </Layout>
    )
  }
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            description
          }
        }
      }
    }
  }
`
